export var EPIC_END = '@@redux-observable/EPIC_END';